import React from "react";



import { Row, Col, Card, CardBody, CardTitle } from "reactstrap";
//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb";
import BusisnessRisk from "../AllCharts/apex/BusisnessRisk";
import FinancialRisk from "../AllCharts/apex/FinancialRisk";
import IndustryRisk from "pages/AllCharts/apex/IndustryRisk";
import OverAllRisk from "pages/AllCharts/apex/OverAllRisk";

const Apexchart = () => {
  document.title = "Apex Charts | Bvo -Dashboard";
  return (
    <React.Fragment>
      <div className="page-content">
        <div className="container-fluid">
          <Breadcrumbs maintitle="Bvo" title="Charts" breadcrumbItem="Apex Charts" />

          <Row>
            <Col lg={6}>
              <Card>
                <CardBody>
                  <h4 className="card-title mb-4">Business Risk</h4>
                  <BusisnessRisk/>
                </CardBody>
              </Card>
            </Col>

            <Col lg={6}>
              <Card>
                <CardBody>
                  <h4 className="card-title mb-4">Financial Risk</h4>
                  <FinancialRisk/>
                </CardBody>
              </Card>
            </Col>
          </Row>
          <Row>
            <Col lg={6}>
              <Card>
                <CardBody>
                  <h4 className="card-title mb-4">Industry Risk</h4>
                  <IndustryRisk/>
                </CardBody>
              </Card>
            </Col>

            <Col lg={6}>
              <Card>
                <CardBody>
                  <h4 className="card-title mb-4">Over All Business Risk</h4>
                  <OverAllRisk/>
                </CardBody>
              </Card>
            </Col>
          </Row>
      
        </div>
      </div>
    </React.Fragment>
  );
};

export default Apexchart;
